module.exports = __webpack_public_path__ + "static/media/mapping-arrow.5f19e5b7.svg";